


















































































































































































































































































































// vue
import { Vue, Component, Prop } from 'vue-property-decorator'

// Vuelidate
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, minLength, email } from 'vuelidate/lib/validators'

// components
import { Form, Input, TextArea, Select, Radio } from '@/components/form'

// utils
import { alerts, loading } from '@/utils'

// constants
import { Countries } from '@/constants'

// models
import { ClientModel, PropOptionSelect, PropOptionRadio, ErrorResponse } from '@/models'

// services
import { ClientService } from '@/services'

@Component({
    name: 'FormClient',
    components: {
        Form,
        Input,
        TextArea,
        Select,
        Radio
    },
    mixins: [validationMixin]
})
export default class FormClient extends Vue {
    @Prop({ required: true }) readonly client!: ClientModel
    @Prop({ required: true }) readonly action!: 'save'|'update'

    form: ClientModel = {
        name: '',
        lastName: '',
        email: '',
        documentNumber: '',
        phoneNumber: '',
        smartphoneNumber: '',
        country: '',
        city: '',
        province: '',
        postalCode: '',
        recommendationCode: '',
        language: '',
        address: '',
        isActive: true
    }

    errors: ErrorResponse[] = []
    countries: PropOptionSelect[] = Countries

    languages: PropOptionSelect[] = [
        {
            value: 'es',
            text: 'Español'
        },
        {
            value: 'en',
            text: 'Inglés'
        },
        {
            value: 'fr',
            text: 'Francés'
        }
    ]

    optionsStatus: PropOptionRadio[] = [
        {
            text: 'ACTIVO',
            value: true
        },
        {
            text: 'INACTIVO',
            value: false
        }
    ]

    created () {
        this.form = this.client
    }

    @Validations()
    validations () {
        return {
            form: {
                email: { required, minLength: minLength(4), email },
                name: { required, minLength: minLength(4) },
                lastName: { required, minLength: minLength(4) },
                documentNumber: { required, minLength: minLength(4) },
                phoneNumber: { required, minLength: minLength(4) },
                smartphoneNumber: { required, minLength: minLength(4) },
                country: { required },
                city: { required },
                province: { required },
                postalCode: { required, minLength: minLength(4) },
                language: { required },
                recommendationCode: { required },
                address: { required, minLength: minLength(4) }
            }
        }
    }

    async saveClient () {
        this.errors = []
        this.$v.$touch()
        if (!this.$v.$anyError) {
            loading('show')
            try {
                const res = await ClientService.save(this.form)
                if (res?.success) {
                    alerts.success()
                    this.$emit('save-success')
                } else {
                    this.errors = res?.errors
                    alerts.error('Se ha presentado errores en la operación')
                }
                loading('hide')
            } catch (e) {
                loading('hide')
            }
            this.$v.$reset()
        } else {
            alerts.error('Debe completar todos los campos requeridos')
        }
    }
}
